export default __webpack_public_path__ + "static/media/culture-little-tablet.27ffdf4c.png";